import "../component_styles/Footer.css";

function Footer() {
  return (
    <footer className="socials">
      <p>Built by Katie and Zimo :D</p>
    </footer>
  );
}

export default Footer;
